import React, { useContext, useState } from 'react';
import { Button } from '@components';
import { Typography } from 'gd-design-library';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import PhoneCallbackIcon from '@mui/icons-material/PhoneCallback';
import PhoneIcon from '@mui/icons-material/Phone';
import { ChatbotWidgetContext } from '../../utils/ChatbotWidgetContext';
import { View } from '../../constants/view';
import styles from './SelectContactOption.module.scss';
import classNames from 'classnames/bind';
import { useStartChat } from 'components/ChatbotWidget/hooks/useStartChat';

const cx = classNames.bind(styles);
const CN = 'select-contact-option';
const buttonsClassName = `${CN}__buttons`;

export const SelectContactOption = (): React.ReactElement => {
  const { setView, options } = useContext(ChatbotWidgetContext);
  const startChat = useStartChat();
  const [ isChatLoading, setIsChatLoading ] = useState(false);

  const handleStartChatClick = (): void => {
    if (options.user.name && options.user.email) {
      setIsChatLoading(true);
      startChat();
    } else {
      setView(View.CHAT_SIGN_IN);
    }
  };

  return (
    <div className={ cx(CN) }>
      <Typography variant='h4' align='center'>Contact Us</Typography>
      <div className={ cx(buttonsClassName) }>
        <Button
          variant='primary'
          iconStart={ <ChatBubbleIcon /> }
          onClick={ handleStartChatClick }
          loading={ isChatLoading }
        >
          Start Chat
        </Button>
        <Button variant='outlined' iconStart={ <PhoneCallbackIcon /> } onClick={ (): void => { setView(View.CALL_SIGN_IN); } }>
          Call Me
        </Button>
        {options.supportPhoneNumber && (
          <Button variant='outlined' iconStart={ <PhoneIcon /> } onClick={ (): void => { window.open(`tel:${options.supportPhoneNumber}`, '_self'); } }>
            Call {options.supportPhoneNumber}
          </Button>
        )}
      </div>
    </div>
  );
};
